import callAPiBase from './base';

const wordCountChartApi = {
  get: ({ startDate, endDate }: { startDate: number, endDate: number }) =>
    callAPiBase({
      endpoint: `/api/reports/messages/count?startDate=${startDate}&endDate=${endDate}`,
      method: 'GET',
      useToken: true,
    }),
};

export { wordCountChartApi };
export default wordCountChartApi;
